export var shortAddress = function shortAddress(account) {
  if (!account) return 'ERROR';
  if (account.length >= 7) return "".concat(account.substr(0, 6), "...").concat(account.substr(-4, 4));else return account;
};